import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const ONCELIK_RENK: Record<string, string> = { 'Dusuk': '#94a3b8', 'Normal': '#1890ff', 'Yuksek': '#ff9500', 'Acil': '#ff4d4f' };

@Component({
  selector: 'is-emri-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" [style.--sk-accent]="oncelikRenk()">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('urunAdi') || 'Isimsiz Is Emri' }}</div>
        @if (deger('makine')) { <div class="sk-alt">{{ deger('makine') }}</div> }
        @if (deger('sorumlu')) { <div class="sk-alt">{{ deger('sorumlu') }}</div> }
        @if (ilerleme() > 0) {
          <div class="sk-bar"><div class="sk-bar-dolgu" [style.width.%]="ilerleme()" [style.background]="oncelikRenk()"></div></div>
        }
      </div>
      <div class="sk-sag">
        @if (deger('oncelik')) { <span class="sk-badge" [style.background]="oncelikRenk()">{{ deger('oncelik') }}</span> }
      </div>
    </div>
  `,
})
export class IsEmriKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  oncelikRenk = computed(() => ONCELIK_RENK[this.deger('oncelik')] || '#1890ff');
  ilerleme = computed(() => +(this.deger('ilerleme') || this.p()?._hesap?.ilerleme || 0));
}
